// NOTE: 결제시나리오
import type { SHARE_EXTEND } from '@/enums/gtagEvents'

import push from './push'

const partner = {
  paymentStart: (couponSeq: number, parkinglotSeq: number) => {
    push({
      event: 'payment_제휴일반_start',
      page: '주차상품상세화면',
      act: '주차상품선택',
      couponSeq,
      pklSeq: parkinglotSeq
    } satisfies GtagPaymentEvent)
  },

  onClickPaymentButton: (couponSeq: number, parkinglotSeq: number) => {
    push({
      event: 'payment_제휴일반_주차상품상세화면',
      page: '주차상품상세화면',
      act: '구매하기',
      couponSeq,
      pklSeq: parkinglotSeq
    } satisfies GtagPaymentEvent)
  },

  approveTerms: () => {
    push({
      event: 'payment_제휴일반_이용약관',
      page: '주차상품이용약관',
      act: '이용약관동의완료'
    } satisfies GtagPaymentEvent)
  },

  onClickNextButton: () => {
    push({
      event: 'payment_제휴일반_입차예정시간',
      page: '입차예정시간',
      act: '입차예정시간선택'
    } satisfies GtagPaymentEvent)
  },

  onLoadCarNum: () => {
    push({
      event: 'payment_제휴일반_차량번호',
      page: '차량번호입력',
      act: '차량번호입력'
    } satisfies GtagPaymentEvent)
  },

  onLoadPhoneAuth: () => {
    push({
      event: 'payment_제휴일반_휴대번호인증',
      page: '전화번호인증',
      act: '전화번호인증'
    } satisfies GtagPaymentEvent)
  },

  choosePaymentMethod: () => {
    push({
      event: 'payment_제휴일반_결제수단선택',
      page: '결제수단선택',
      act: '결제하기'
    } satisfies GtagPaymentEvent)
  },

  completePayment: (couSeq: number) => {
    push({
      event: 'payment_제휴일반_complete',
      page: '결제완료',
      act: '결제완료',
      couSeq
    } satisfies GtagPaymentEvent)
  }
}

const shared = {
  paymentStart: (shareSeq: number) => {
    push({
      event: 'payment_공유_start',
      page: '공유주차장정보',
      act: '공유주차장선택',
      shareSeq
    } satisfies GtagPaymentEvent)
  },

  // approveTerms: () => {
  //   push({
  //     event: 'payment_공유_이용약관',
  //     page: '주차상품이용약관',
  //     act: '이용약관동의완료'
  //   } satisfies GtagPaymentEvent)
  // },

  onClickNextButton: () => {
    push({
      event: 'payment_공유_주차시간선택',
      page: '주차시간선택',
      act: '주차시간선택'
    } satisfies GtagPaymentEvent)
  },

  onLoadCarNum: () => {
    push({
      event: 'payment_공유_차량번호',
      page: '차량번호입력',
      act: '차량번호입력'
    } satisfies GtagPaymentEvent)
  },

  onLoadPhoneAuth: () => {
    push({
      event: 'payment_공유_휴대번호인증',
      page: '휴대폰번호인증',
      act: '휴대폰번호인증'
    } satisfies GtagPaymentEvent)
  },

  choosePaymentMethod: () => {
    push({
      event: 'payment_공유_결제수단선택',
      page: '결제수단선택',
      act: '결제수단선택'
    } satisfies GtagPaymentEvent)
  },

  completePayment: (parkingSeq: number, ifExt: SHARE_EXTEND) => {
    push({
      event: 'payment_공유_complete',
      page: '결제완료',
      act: '결제완료',
      parkingSeq,
      ifExt
    } satisfies GtagPaymentEvent)
  },

  extendPayment: (shareSeq: number) => {
    push({
      event: 'payment_공유_연장하기',
      page: '공유주차장정보',
      act: '공유주차장선택',
      shareSeq
    } satisfies GtagPaymentEvent)
  }
}

const paymentEvents = {
  partner,
  shared
}

export default paymentEvents
